import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App, router } from './App'; // ADR 0015 — router now exported
import { initSentry } from './lib/sentry';
import { initPostHog } from './lib/posthog';
import './index.css';

// Init BEFORE render so early/mount errors are captured (§4.A). Both are PROD-gated internally (no dev events).
// Sentry FIRST, then PostHog (spec §5: "posthog.init AFTER Sentry"); PostHog↔Sentry replay link relies on this order (§6).
initSentry(router);
initPostHog();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
